import React, { FunctionComponent, useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Common
import { GENERAL } from '../../../../constants';

// Components
import { Tile } from '../../../Tile';
import {
    FormTextField,
    FormInputMask
} from '../FormInputs';

// Properties
import * as styles from './FormPersonal.styles';

const FormPersonal: FunctionComponent = () => {
    const { values } = useFormikContext();

    const handleValidateChangePhone = (value: string) => {
        if(values.callMarketing){
            if (!value) {
                return GENERAL.PERSONAL_PHONE_VALIDATION;
            }
        }
    };

    return (
        <Tile title={GENERAL.PERSONAL_TITLE}>
            <Box>
                <Box sx={styles.fieldsThird}>
                    <Field
                        name="firstName"
                        label={GENERAL.PERSONAL_FIRSTNAME}
                        required
                        component={FormTextField}
                    />
                    <Field
                        name="lastName"
                        label={GENERAL.PERSONAL_LASTNAME}
                        required
                        component={FormTextField}
                    />
                </Box>
                <Box sx={styles.fieldsThird}>
                    <Field
                        name="email"
                        type="email"
                        label={GENERAL.PERSONAL_EMAIL}
                        required
                        component={FormTextField}
                    />
                    <Field
                        name="phoneNumber"
                        component={FormInputMask}
                        required={values.callMarketing}
                        validate={handleValidateChangePhone}
                    />
                </Box>
            </Box>
            <Box sx={styles.caption}>
                <Typography variant="caption">
                    {GENERAL.REQUIRED}
                </Typography>
            </Box>
        </Tile>
    );
};

export default FormPersonal;
